// extracted by mini-css-extract-plugin
export var cardLayout = "_90-1";
export var paginationContainer = "_90-0";